import * as React from 'react';
import { SVGProps } from 'react';

const SvgNotificationsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.203 3.327a.818.818 0 0 0-1.31.982 7.365 7.365 0 0 1 1.473 4.42.818.818 0 0 0 1.637 0 9.001 9.001 0 0 0-1.8-5.402ZM5.952 3.168a.818.818 0 0 1 .153 1.147C5.154 5.56 4.637 7.102 4.637 8.728a.818.818 0 0 1-1.637 0c0-1.974.629-3.869 1.805-5.407a.818.818 0 0 1 1.147-.153ZM12.002 3a5.728 5.728 0 0 0-5.729 5.728c0 2.744-.587 4.447-1.127 5.439a4.858 4.858 0 0 1-.72 1.018 2.47 2.47 0 0 1-.25.232l-.003.002a.818.818 0 0 0 .464 1.492h14.73a.818.818 0 0 0 .463-1.492l-.003-.002a2.487 2.487 0 0 1-.25-.232 4.86 4.86 0 0 1-.72-1.018c-.54-.992-1.127-2.695-1.127-5.439A5.728 5.728 0 0 0 12 3Zm5.605 12.275H6.395c.063-.102.125-.21.187-.324.687-1.26 1.328-3.238 1.328-6.223a4.092 4.092 0 1 1 8.183 0c0 2.985.64 4.964 1.327 6.223.063.114.125.222.187.324Zm-6.313 3.68a.818.818 0 0 0-1.416.822 2.456 2.456 0 0 0 4.247 0 .818.818 0 0 0-1.416-.821.82.82 0 0 1-1.415 0Z"
      fill="currentColor"
      fillOpacity={0.8}
    />
  </svg>
);

export default SvgNotificationsIcon;
